export default __webpack_public_path__ + "static/climate-change-mobile-banner-215265d8106b89f883b25ba957d634cd.png";